import { LogLevel } from "@azure/msal-browser";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_SIGN_UP_SIGN_IN,
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://' + process.env.REACT_APP_AZURE_LOGIN + '.b2clogin.com/' + process.env.REACT_APP_AZURE_LOGIN + '.onmicrosoft.com/' + process.env.REACT_APP_SIGN_UP_SIGN_IN,
        },
    },
    authorityDomain: 'https://' + process.env.REACT_APP_AZURE_LOGIN + '.b2clogin.com/',
};

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    audit: {
        apiAppUser: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/AppUserAudit/',
        },
        apiAppUserLab: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/AppUserLabAudit/',
        },
        apiKit: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/KitAudit/',
        },
        apiKitTracking: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/KitTrackingAudit/',
        },
        apiComment: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/CommentAudit/',
        },
        apiLab: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/LabAudit/',
        },
        apiLabInvite: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/LabInviteAudit/',
        },
        apiSubmittedKit: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/SubmittedKitAudit/',
        },
        apiSubmittedKitRun: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/SubmittedKitRunAudit/',
        },
        apiPipet: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/PipetAudit/',
        },
        apiOperator: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/OperatorAudit/',
        },
        apiReport: {
            endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/ReportAudit/',
        },
    },
    apiAppUser: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/User/',
    },
    apiAppUserLab: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/AppUserLab/',
    },
    apiKit: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/Kit/',
    },
    apiComment: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/Comment/',
    },
    apiLab: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/Lab/',
    },
    apiDuplicateLabMerge: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/DuplicateLabMerge/',
    },
    apiLabInvite: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/LabInvite/',
    },
    apiSubmittedKit: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/SubmittedKit/',
    },
    apiSubmittedKitRun: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/SubmittedKitRun/',
    },
    apiPipet: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/Pipet/',
    },
    apiOperator: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/Operator/',
    },
    apiReport: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/Report/',
    },
    apiLegacyReport: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'api/v1.0/LegacyReport/',
    },
    apiHangfire: {
        endpoint: process.env.REACT_APP_API_ENDPOINT + 'hangfire',
    },
    scopes: {
        admin: ['https://' + process.env.REACT_APP_AZURE_LOGIN + '.onmicrosoft.com/' + process.env.REACT_APP_AZURE_SCOPE + '/PVS.Admin'],
        user: ['https://' + process.env.REACT_APP_AZURE_LOGIN + '.onmicrosoft.com/' + process.env.REACT_APP_AZURE_SCOPE + '/PVS.User'],
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [...protectedResources.scopes.admin, ...protectedResources.scopes.user],
    prompt: "login"
};

/**
 * IMPORTANT: In case of overage, group list is cached for 1 hr by default, and thus cached groups 
 * will miss any changes to a users group membership for this duration. For capturing real-time 
 * changes to a user's group membership, consider implementing Microsoft Graph change notifications. 
 * For more information, visit: https://learn.microsoft.com/graph/api/resources/webhooks
 */
export const CACHE_TTL_IN_MS = 15 * 60 * 1000; // 1 hour in milliseconds
